import { createRoute } from '@tanstack/react-router';
import { Route as parentRoute } from '../../devices/index';
import KioskDeviceEditPage from '@/features/kiosk/pages/KioskDeviceEditPage';

export const Route = createRoute({
  getParentRoute: () => parentRoute,
  path: '/edit/$id',
  component: KioskDeviceEditPage,
});
